import React, { useEffect, useRef } from 'react';
import QrScanner from 'qr-scanner';
import './SimpleQRScanner.css';

interface SimpleQRScannerProps {
  onScan: (data: string) => void;
  onError: (error: string) => void;
  onClose: () => void;
}

const SimpleQRScanner: React.FC<SimpleQRScannerProps> = ({ onScan, onError, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const scannerRef = useRef<QrScanner | null>(null);

  useEffect(() => {
    if (!videoRef.current) return;

    scannerRef.current = new QrScanner(
      videoRef.current,
      (result) => {
        onScan(result.data);
      },
      {
        highlightScanRegion: true,
        highlightCodeOutline: true,
        preferredCamera: 'environment'
      }
    );

    scannerRef.current.start().catch((error) => {
      console.error('QR Scanner failed to start:', error);
      onError('Kamera konnte nicht gestartet werden. Bitte erlaube Kamera-Zugriff.');
    });

    return () => {
      if (scannerRef.current) {
        scannerRef.current.destroy();
      }
    };
  }, [onScan, onError]);

  return (
    <div className="qr-scanner-overlay">
      <div className="qr-scanner-container">
        <div className="scanner-header">
          <h3>QR-Code scannen</h3>
          <button onClick={onClose} className="close-scanner">
            ✕
          </button>
        </div>
        <video ref={videoRef} className="qr-video" />
        <p>QR-Code vor die Kamera halten</p>
      </div>
      
    </div>
  );
};

export default SimpleQRScanner;